/* Live Free — hover/tap tooltips for screening categories and certification
   chips (BUILD-07 §2, §3). One delegated listener per container. The tooltip
   content is already in the HTML (hidden), so this only toggles visibility:
   hover and focus open, leaving closes, click/tap toggles and pins, Escape
   closes. Under 1.5KB, no dependencies. */
(function () {
  'use strict';
  var containers = document.querySelectorAll('[data-lf-tips]');
  if (!containers.length) return;
  Array.prototype.forEach.call(containers, function (box) {
    var pinned = null;
    function tipFor(btn) { var id = btn.getAttribute('aria-controls'); return id ? document.getElementById(id) : null; }
    function closeAll(except) {
      Array.prototype.forEach.call(box.querySelectorAll('[aria-controls][aria-expanded="true"]'), function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false'); var t = tipFor(b); if (t) t.hidden = true;
      });
    }
    function open(btn) { closeAll(btn); var t = tipFor(btn); if (!t) return; btn.setAttribute('aria-expanded', 'true'); t.hidden = false; }
    function close(btn) { if (btn === pinned) return; var t = tipFor(btn); if (!t) return; btn.setAttribute('aria-expanded', 'false'); t.hidden = true; }
    function target(e) { return e.target.closest && e.target.closest('[aria-controls]'); }
    box.addEventListener('mouseover', function (e) { var b = target(e); if (b && box.contains(b) && !pinned) open(b); });
    box.addEventListener('mouseout', function (e) { var b = target(e); if (!b) return; var to = e.relatedTarget; if (to && (b.contains(to) || (tipFor(b) && tipFor(b).contains(to)))) return; close(b); });
    box.addEventListener('focusin', function (e) { var b = target(e); if (b) open(b); });
    box.addEventListener('focusout', function (e) { var b = target(e); if (b) close(b); });
    box.addEventListener('click', function (e) {
      var b = target(e); if (!b) return;
      e.preventDefault();
      if (pinned === b) { pinned = null; b.setAttribute('aria-expanded', 'false'); var t = tipFor(b); if (t) t.hidden = true; return; }
      pinned = b; open(b);
    });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pinned = null; closeAll(); } });
  });
})();